import React from 'react';
import { Users, Briefcase, Award, Headset } from 'lucide-react';

export default function WhyChooseUs() {
  const stats = [
    {
      number: '150+',
      label: 'Happy Clients',
      icon: Users,
    },
    {
      number: '300+',
      label: 'Projects Delivered',
      icon: Briefcase,
    },
    {
      number: '10+',
      label: 'Years of Experience',
      icon: Award,
    },
    {
      number: '24/7',
      label: 'Support Available',
      icon: Headset,
    },
  ];

  return (
    <section className="w-full bg-[#F0F6FF] py-12 sm:py-16 border-y border-blue-100/60 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* SECTION HEADER */}
        <div className="text-center mb-10 sm:mb-12 space-y-2">
          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#f25c05] uppercase">
            WHY CHOOSE INIMAI SOLUTIONS?
          </p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#0B192C] tracking-tight">
            Driving Innovation. Delivering Excellence.
          </h2>
        </div>

        {/* STATS GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0 items-center">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;

            return (
              <div
                key={index}
                className={`flex items-center justify-start sm:justify-center px-4 lg:px-6 ${
                  index !== stats.length - 1
                    ? 'lg:border-r lg:border-blue-200/70 border-b sm:border-b-0 border-blue-100 pb-6 sm:pb-0'
                    : ''
                }`}
              >
                <div className="flex items-center space-x-4">
                  
                  {/* Icon Badge Container */}
                  <div className="flex-shrink-0 p-3 sm:p-3.5 bg-blue-100/80 rounded-2xl flex items-center justify-center">
                    <IconComponent className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-[#f25c05]" />
                  </div>

                  {/* Text Content */}
                  <div className="flex flex-col">
                    <span className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#0B192C] leading-none">
                      {stat.number}
                    </span>
                    <span className="text-xs sm:text-sm font-medium text-gray-600 mt-1">
                      {stat.label}
                    </span>
                  </div>

                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}